// src/components/BackgroundCardWall.jsx
import React, { useEffect, useRef } from 'react';
import { getBackgroundCards } from '../../constants/WallConstants.ts';
import './BackgroundCardWall.css';

const Card = ({ item }) => {
  const formatLikes = (n) => {
    if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
    return String(n);
  };

  return (
    <div className="feed-card">
      <img 
        src={item.imageUrl} 
        alt={item.title}
        className="feed-card-image"
      />
      
      <div className="feed-card-gradient" />
      
      <div className="feed-card-play-pill">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
          <path d="M8 5v14l11-7z"/>
        </svg>
      </div>
      
      <div className="feed-card-like-pill">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
          <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
        </svg>
        <span>{formatLikes(item.likes)}</span>
      </div>
      
      <div className="feed-card-content">
        <h3 className="feed-card-title">{item.title}</h3>
        <p className="feed-card-user">@{item.publishedBy}</p>
      </div>
    </div>
  );
};

const BackgroundCardWall = ({ count = 24 }) => {
  const items = getBackgroundCards(count);
  
  const colA = items.filter((_, idx) => idx % 2 === 0);
  const colB = items.filter((_, idx) => idx % 2 === 1);
  
  const columnARef = useRef(null);
  const columnBRef = useRef(null);

  useEffect(() => {
    const colAEl = columnARef.current;
    const colBEl = columnBRef.current;
    
    if (!colAEl || !colBEl) return;

    let animationFrameA, animationFrameB;
    let startTimeA = Date.now();
    let startTimeB = Date.now() + 1200;

    const DURATION_A = 18000;
    const DURATION_B = 12000;
    const TRAVEL_DISTANCE = 200;

    const animateColumnA = () => {
      const elapsed = Date.now() - startTimeA;
      const progress = (elapsed % (DURATION_A * 2)) / DURATION_A;
      
      let yPercent;
      if (progress < 1) {
        yPercent = -progress * TRAVEL_DISTANCE;
      } else {
        yPercent = -(2 - progress) * TRAVEL_DISTANCE;
      }
      
      colAEl.style.transform = `translateY(${yPercent}%)`;
      animationFrameA = requestAnimationFrame(animateColumnA);
    };

    const animateColumnB = () => {
      const elapsed = Date.now() - startTimeB;
      const progress = (elapsed % (DURATION_B * 2)) / DURATION_B;
      
      let yPercent;
      if (progress < 1) {
        yPercent = -progress * TRAVEL_DISTANCE;
      } else {
        yPercent = -(2 - progress) * TRAVEL_DISTANCE;
      }
      
      colBEl.style.transform = `translateY(${yPercent}%)`;
      animationFrameB = requestAnimationFrame(animateColumnB);
    };

    animateColumnA();
    setTimeout(() => animateColumnB(), 1200);

    return () => {
      if (animationFrameA) cancelAnimationFrame(animationFrameA);
      if (animationFrameB) cancelAnimationFrame(animationFrameB);
    };
  }, []);

  return (
    <div className="background-card-wall">
      <div className="card-wall-columns">
        <div ref={columnARef} className="card-wall-column">
          {colA.map((card) => (
            <Card key={`A-${card.id}`} item={card} />
          ))}
        </div>
        
        <div ref={columnBRef} className="card-wall-column">
          {colB.map((card) => (
            <Card key={`B-${card.id}`} item={card} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BackgroundCardWall;